module.exports = __webpack_public_path__ + "static/media/notification-orange.e80c7c96.svg";